/* eslint-disable @typescript-eslint/camelcase */
import React from 'react';
import { RoleProps } from 'modules/permission/interfaces';
import { connect } from 'react-redux';
import { Grid, makeStyles, Typography } from '@material-ui/core';
import { Formik } from 'formik';
import GenericForm from 'skyone-lib/lib/GenericForm';
import { applyI18n } from 'utils/helpers';
import i18n from 'i18n';
import { modalClose } from 'modules/modal/actions';
import { cloneRoleRequest } from 'modules/permission/actions';
import Button from 'components/Button';
import ApplicationState from 'store/interfaces';
import { RolesEnum } from 'modules/authenticate/interfaces';
import { Query } from 'hooks/useTableFilters';
import screenFields from './screenFields';
import { schema } from './schema';
import styles from './styles';

const useStyles = makeStyles(styles);

interface FormCloneGroupProps {
  groupToClone: RoleProps;
  role?: RolesEnum;
  query: Query;
  cloneRoleRequest: (values) => void;
  modalClose: () => void;
}

const initialValues = {
  name: '',
  description: '',
};

const FormCloneGroup = ({
  groupToClone,
  role,
  query,
  cloneRoleRequest,
  modalClose,
}: FormCloneGroupProps) => {
  const classes = useStyles();

  const handleSubmit = (values: typeof initialValues) => {
    cloneRoleRequest({
      role_uuid: groupToClone.role_uuid,
      operator_role: role,
      query,
      ...values,
    });
  };

  return (
    <Grid item container>
      <Formik
        initialValues={initialValues}
        onSubmit={handleSubmit}
        validationSchema={schema}
        enableReinitialize
      >
        {({ errors, values, setFieldValue, submitForm }) => (
          <Grid container spacing={2}>
            <Grid className={classes.titleGrid}>
              <Grid container alignItems="center">
                <Typography>
                  {`${i18n.t('GROUPS_PAGE.CLONE_GROUP_TO_CLONE_KEY')}:`}
                </Typography>
                <Grid item>
                  <Button id="btn-select-group" disabled={true}>
                    <Typography style={{ fontWeight: 'bold' }}>
                      {groupToClone?.name}
                    </Typography>
                  </Button>
                </Grid>
              </Grid>
            </Grid>
            <GenericForm
              overrideClasses={{
                selectLabel: { fontSize: 12, fontWeight: 500 },
              }}
              fields={values}
              screenFields={applyI18n(screenFields.slice(0, 2), i18n.language)}
              setFieldValue={setFieldValue}
              errors={errors}
            />

            <Grid container justify="flex-end" className={classes.buttonsBase}>
              <Grid container className={classes.buttonsAlign}>
                <Button id="submit-button" submitButton onClick={submitForm}>
                  {i18n.t('CLONE_KEY')}
                </Button>
                <Button
                  id="cancel-button"
                  variant="outlined"
                  onClick={modalClose}
                >
                  {i18n.t('CANCEL_KEY')}
                </Button>
              </Grid>
            </Grid>
          </Grid>
        )}
      </Formik>
    </Grid>
  );
};

const mapStateToProps = ({ authenticate: { data } }: ApplicationState) => ({
  role: data?.role,
});

export default connect(mapStateToProps, { cloneRoleRequest, modalClose })(
  FormCloneGroup
);
